module.exports = __webpack_public_path__ + "static/media/Administracion1.b5552ff.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audios/Administracion1.mp3
// module id = 708
// module chunks = 1